<template>
  <fieldset
    :key="thingThatICanIncrementToForceAnImmediateRedraw"
    class="starability-basic display"
    :class="{
      [`starability-basic--${size}`]: size,
    }"
  >
    <legend>Calificación de estrellas:</legend>
    <input
      :id="`rate5-${_uid}`"
      :class="{ checked: rating === 5 }"
      name="rating"
      value="5"
    />
    <label
      :for="`rate5-${_uid}`"
      title="EXCELENTE - Consideraría seleccionar este diseño como el ganador"
      aria-label="EXCELENTE - Consideraría seleccionar este diseño como el ganador"
      data-test-rating="excellent"
    >
      5 estrellas
    </label>
    <input
      :id="`rate4-${_uid}`"
      :class="{ checked: rating === 4 }"
      name="rating"
      value="4"
    />
    <label
      :for="`rate4-${_uid}`"
      title="MUY BIEN - Propuesta de alta calidad que necesita un poco  de trabajo. "
      aria-label="MUY BIEN - Propuesta de alta calidad que necesita un poco  de trabajo. "
      data-test-rating="very-good"
    >
      4 estrellas
    </label>
    <input
      :id="`rate3-${_uid}`"
      :class="{ checked: rating === 3 }"
      name="rating"
      value="3"
    />
    <label
      :for="`rate3-${_uid}`"
      title="BUENO - Buen intento, pero no está compitiendo por el primer lugar a menos que se realicen cambios"
      aria-label="BUENO - Buen intento, pero no está compitiendo por el primer lugar a menos que se realicen cambios"
      data-test-rating="good"
    >
      3 estrellas
    </label>
    <input
      :id="`rate2-${_uid}`"
      :class="{ checked: rating === 2 }"
      name="rating"
      value="2"
    />
    <label
      :for="`rate2-${_uid}`"
      title="MALO - No me gusta este diseño pero quisiera que el diseñador vuelva a intentarlo"
      aria-label="MALO - No me gusta este diseño pero quisiera que el diseñador vuelva a intentarlo"
      data-test-rating="poor"
    >
      2 estrellas
    </label>
    <input
      :id="`rate1-${_uid}`"
      :class="{ checked: rating === 1 }"
      name="rating"
      value="1"
    />
    <label
      :for="`rate1-${_uid}`"
      title="MUY POBRE - El diseño no sigue los lineamientos del brief o la calidad es extremadamente baja."
      aria-label="MUY POBRE - El diseño no sigue los lineamientos del brief o la calidad es extremadamente baja."
      data-test-rating="very-poor"
    >
      1 estrella
    </label>
  </fieldset>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: undefined,
    },
    rating: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      thingThatICanIncrementToForceAnImmediateRedraw: 0,
    };
  },
};
</script>
